export function InputCheckboxIcon({ ...props }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H4ZM3.33333 4C3.33333 3.63181 3.63181 3.33333 4 3.33333H12C12.3682 3.33333 12.6667 3.63181 12.6667 4V12C12.6667 12.3682 12.3682 12.6667 12 12.6667H4C3.63181 12.6667 3.33333 12.3682 3.33333 12V4ZM11.5121 6.42679C11.7479 6.14394 11.7096 5.72356 11.4268 5.48785C11.1439 5.25214 10.7236 5.29036 10.4879 5.57321L7.55065 9.09786L5.72082 7.79085C5.42122 7.57684 5.00485 7.64624 4.79084 7.94585C4.57684 8.24545 4.64623 8.66182 4.94584 8.87583L7.78269 10.9021L11.5121 6.42679Z"
        fill="currentColor"
      />
    </svg>
  );
}
